import mcbDialogProvider from './dialogProvider';

/**
 * @ngdoc module
 * @name mcb.components.toast
 *
 * Toast service is implemented by using dress-code styles
 * and heavily inspired by ngDialog
 *
 * ngDialog - easy modals and popup windows
 * http://github.com/likeastore/ngDialog
 * (c) 2013-2015 MIT License, https://likeastore.com
 */
export default angular
  .module('mcb.components.dialog', [])
  // @ts-ignore
  .provider('mcbDialog', mcbDialogProvider);
